import React from 'react';
import { formatAmount } from '../../utils/format';
import noImage from '../../icons/noImageIcon.svg';

const ProductCard = ({ image, name, price, reference, onClick, optionsMenu }) => {

  const handleImageError = (e) => {
    e.target.src = noImage;
    e.target.style.width = "50px";
    e.target.style.height = "50px";
  };

  return (
    <div
      className="bg-[#FFFFFF] shadow-[0px_6px_26px_rgba(98,107,125,0.07)] rounded-[12px] flex p-3 w-full min-w-[200px] cursor-pointer h-[140px]"
      style={{ boxShadow: '0px 6px 26px #626B7D12' }}
      onClick={onClick}
    >
      {/* Fixed image container */}
      <div className="w-[100px]  shadow-[0px_6px_26px_rgba(98,107,125,0.07)] rounded-lg flex items-center justify-center overflow-hidden bg-white">
        <img
          src={image}
          alt={name}
          className="object-contain w-full h-full"
          onError={handleImageError}
        />
      </div>

      {/* Content section taking remaining width */}
      <div className="flex-grow pl-4 flex flex-col justify-between">
        <div>
          <p className="text-[12px] font-bold text-[#ACAFC6]">{reference}</p>
          <h3 className="text-[14px] font-semibold text-gray-800">{name}</h3>
        </div>
        <div className="mt-auto flex justify-between items-end">
          <p className="text-[18px] text-secondary font-bold">
            {formatAmount(price)}
          </p>
          {optionsMenu && (
            <div className="flex-shrink-0">
              {optionsMenu}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
